import { openMetadataApiClient } from '@/shared/api/core/axios-instance';

import type { GlossaryResponse, GlossaryTermItem } from '@/entities/glossary';

type GetGlossaryTermParams = {
  directChildrenOf?: string;
  limit?: number;
  after?: string;
};

export type GetGlossaryTermResponse = GlossaryResponse<GlossaryTermItem>;

export const getGlossaryTermTreeApi = async ({ directChildrenOf = '', limit = 3000 }: GetGlossaryTermParams) => {
  const { data } = await openMetadataApiClient.get<GetGlossaryTermResponse>('/glossaryTerms', {
    params: {
      ...(directChildrenOf && { directChildrenOf }),
      limit,
      fields: 'childrenCount,owners,reviewers,synonyms,relatedTerms,description',
    },
  });
  return data;
};
